import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { getControlBarComponentsSelector } from '../../../redux/ui/controlbar/selectors';
import theme, { mainColors } from '../../../styling/theme';
import { zIndexes } from '../../../styling/zIndexes';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  controlBarRoot: {
    height: '3.75rem',
    width: '100vw',
    padding: '0.62rem 1.25rem 0.62rem 0.31rem',
    backgroundColor: 'white',
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: zIndexes.titleBar,
  },
  controlBarContents: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  toggleIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: mainColors.Fail,
    cursor: 'pointer',
    '& svg': {
      fontSize: '1.88rem',
    },
    '&:hover': {
      color: mainColors.Fail_darker,
    },
    '&:active': {
      color: mainColors.Fail_even_darker,
    },
  },
});

// const ControlBar: FC = () => {
//   const classes = useStyles();
//   const controlBarComponents = useSelector(getControlBarComponentsSelector);

//   return (
//     <div className={classes.controlBarRoot}>
//       <div className={classes.controlBarContents}>
//         {controlBarComponents
//           ? controlBarComponents.map(
//               (controlBarComponent: ReactElement, index: number) => (
//                 <React.Fragment key={index}>
//                   {controlBarComponent}
//                 </React.Fragment>
//               ),
//             )
//           : null}
//       </div>
//     </div>
//   );
// };

// export default ControlBar;

const ControlBar: FC = () => {
  const controlBarComponents = useSelector(getControlBarComponentsSelector);

  return (
    <div className="z-[var(--z-title-bar)] flex h-[3.75rem] w-screen items-center justify-between border-b border-gray-100 bg-white px-5 py-2.5 pl-1 pr-5">
      <div className="flex w-full justify-between">
        {controlBarComponents?.map(
          (controlBarComponent: ReactElement, index: number) => (
            <React.Fragment key={index}>{controlBarComponent}</React.Fragment>
          ),
        )}
      </div>
    </div>
  );
};

export default ControlBar;
